// test1599
(1599 && 0);
